export const DEFAULT_WEEK_START_DAY = "sunday";
